import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {BuildKit} from "../../shared/models/build-kit.model";
import camelcaseKeys from "camelcase-keys";
import {RolePermission} from "../../shared/models/role-permission.model";

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  create(newRolePermission: RolePermission): Observable<any> {
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'rolePermission/create/',
      camelcaseKeys(newRolePermission as any, {deep: true, pascalCase: true}));
  }

  createBulk(newRolePermission: RolePermission[]): Observable<any> {
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'rolePermission/createBulk/',
      camelcaseKeys({rolePermissions: newRolePermission}, {deep: true, pascalCase: true}));
  }

  remove(rolePermissionId: string): Observable<string>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `rolePermission/delete/${rolePermissionId}/`);
  }

  removeBulk(rolePermissionIds: string[]): Observable<string[]>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'rolePermission/deleteBulk/',
      camelcaseKeys({rolePermissionIds: rolePermissionIds}, {deep: true, pascalCase: true}))
      .pipe(map(x => x?.data?.rolePermissionIds ?? []));  }

  update(updatedRolePermission: RolePermission): Observable<any>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'rolePermission/modify/',
      camelcaseKeys(updatedRolePermission as any , {deep:true, pascalCase: true}));

  }





}
